<template>
  <div :id="tableContent.id">
    <p v-html="tableContent.title"></p>
    <table>
      <tbody v-html="tableContent.table"></tbody>
      <tfoot v-html="tableContent.footer"></tfoot>
    </table>
  </div>

</template>
<script>
  export default {
    name: 'content-table',
    props: ['tableContent']
  }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ContentTableComponent.vue?4cca76e7